import { VideoConsultationNotificationConfiguration } from '@dreryk/egabinet-phone-notification-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';

import { patientPhoneNotificationTranslationKeys } from '../../../translations';

const t =
   patientPhoneNotificationTranslationKeys.notificationToggle.videoConsultationReminderToggleAdditionalInformationMap;

export const getAdditionalInformation = (
   config: VideoConsultationNotificationConfiguration,
   translate: TranslateFunction
): string => {
   const {
      cancellationAfterEarlyNotificationEnabled,
      cancellationAfterLateNotificationEnabled,
      earlyNotificationEnabled,
      lateNotificationEnabled,
   } = config;

   const translationParts: string[] = [];

   if (lateNotificationEnabled) {
      translationParts.push(
         translate(
            cancellationAfterLateNotificationEnabled ? t.onlyLateNotificationWithCancellation : t.onlyLateNotification
         )
      );
   }

   if (earlyNotificationEnabled) {
      translationParts.push(
         translate(
            cancellationAfterEarlyNotificationEnabled
               ? t.onlyEarlyNotificationWithCancellation
               : t.onlyEarlyNotification
         )
      );
   }

   return translationParts.length > 0 ? translationParts.join(', ') : translate(t.noOptionsSelected);
};
